export const audienceExpressionStyle = () => ({
  '.cnf-or-dnf-panel': {
    '& .dnf-panel-body, & .cnf-panel-body': {
      paddingLeft: '0px',
    },
    '& #ExpressionGroupDropDown': {
      marginLeft: '15px',
      marginTop: '8px',
      width: '200px',
    },
    '& .conditionsPanel': {
      background: '#F3F2F1',
      marginTop: '8px',
      paddingBottom: '12px',
      '& .condition-title': {
        fontWeight: 'normal',
      },
      '& .col-sm-3': {
        paddingRight: '0px',
        '& .remove-button, & .remove-button-readonly': {
          display: 'flex',
          '& .remove-text': {
            marginTop: '4px',
          },
        },
      },
      '& input[disabled],.disabled': {
        color: '#a19f9d',
      },
      '& .predicateDropDown, .conjunctionDropDown,.conditionText': {
        backgroundColor: '#FFFFFF',
      },
      '& .filtercloseimage': {
        top: '5px',
        color: '#605e5c',
        right: '8px',
        cursor: 'pointer',
        position: 'relative',
        fontFamily: 'MsAds MDL2 Assets',
        paddingLeft: '5px',
      },
      '& .filtercloseimage:before': {
        content: '"\\E711"',
      },
    },

    '& .rule-group-operator-button': {
      marginTop: '15px',
    },

    '& .operatorButton': {
      marginLeft: '15px',
    },

  },
});
